import React from 'react';
import { Route, useLocation } from 'react-router-dom';

export const HashRoute = ({ hash, ...routeProps }) => {
  const location = useLocation();

  return location.hash === hash ? <Route {...routeProps} /> : null;
};
